/* @generated from adl module CodeDiagnostics */

import * as ADL from './runtime/adl';
import * as Path from './Path';
import * as SrcLoc from './SrcLoc';

export enum CodeDiagnosticSeverity {
  Fatal,
  SyntaxError,
  CompilerError,
  CompilerWarning,
  LintWarning,
  Lint,
  StyleLint,
}

const CodeDiagnosticSeverity_AST : ADL.ScopedDecl =
  {"moduleName":"CodeDiagnostics","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"Fatal","default":{"kind":"nothing"},"name":"Fatal","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"SyntaxError","default":{"kind":"nothing"},"name":"SyntaxError","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"CompilerError","default":{"kind":"nothing"},"name":"CompilerError","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"CompilerWarning","default":{"kind":"nothing"},"name":"CompilerWarning","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"LintWarning","default":{"kind":"nothing"},"name":"LintWarning","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"Lint","default":{"kind":"nothing"},"name":"Lint","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"StyleLint","default":{"kind":"nothing"},"name":"StyleLint","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"CodeDiagnosticSeverity","version":{"kind":"nothing"}}};

export const snCodeDiagnosticSeverity: ADL.ScopedName = {moduleName:"CodeDiagnostics", name:"CodeDiagnosticSeverity"};

export function texprCodeDiagnosticSeverity(): ADL.ATypeExpr<CodeDiagnosticSeverity> {
  return {value : {typeRef : {kind: "reference", value : snCodeDiagnosticSeverity}, parameters : []}};
}

export interface CodeDiagnostic {
  severity: CodeDiagnosticSeverity;
  filePath: (Path.PathRelFile|null);
  srcSpan: (SrcLoc.SrcSpan|null);
  message: string;
}

export function makeCodeDiagnostic(
  input: {
    severity: CodeDiagnosticSeverity,
    filePath: (Path.PathRelFile|null),
    srcSpan: (SrcLoc.SrcSpan|null),
    message: string,
  }
): CodeDiagnostic {
  return {
    severity: input.severity,
    filePath: input.filePath,
    srcSpan: input.srcSpan,
    message: input.message,
  };
}

const CodeDiagnostic_AST : ADL.ScopedDecl =
  {"moduleName":"CodeDiagnostics","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"severity","default":{"kind":"nothing"},"name":"severity","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"CodeDiagnostics","name":"CodeDiagnosticSeverity"}},"parameters":[]}},{"annotations":[],"serializedName":"filePath","default":{"kind":"nothing"},"name":"filePath","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"Path","name":"PathRelFile"}},"parameters":[]}]}},{"annotations":[],"serializedName":"srcSpan","default":{"kind":"nothing"},"name":"srcSpan","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"SrcLoc","name":"SrcSpan"}},"parameters":[]}]}},{"annotations":[],"serializedName":"message","default":{"kind":"nothing"},"name":"message","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"CodeDiagnostic","version":{"kind":"nothing"}}};

export const snCodeDiagnostic: ADL.ScopedName = {moduleName:"CodeDiagnostics", name:"CodeDiagnostic"};

export function texprCodeDiagnostic(): ADL.ATypeExpr<CodeDiagnostic> {
  return {value : {typeRef : {kind: "reference", value : snCodeDiagnostic}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "CodeDiagnostics.CodeDiagnosticSeverity" : CodeDiagnosticSeverity_AST,
  "CodeDiagnostics.CodeDiagnostic" : CodeDiagnostic_AST
};
